module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/variant-b-credits-online-ff22bd64cb4f9fdd464ccc9b595fbd0c.png";